import { BROADER_JOURNEY_IDS, applyBroaderJourneyQuality } from './broaderJourneyQuality.js';
import { FOUNDATION_JOURNEY_IDS, applyFoundationJourneyQuality } from './foundationJourneyQuality.js';
import { SPECIALIST_JOURNEY_IDS, applySpecialistJourneyQuality } from './specialistJourneyQuality.js';

export const QUALITY_MANAGED_JOURNEY_IDS = Object.freeze([
  ...FOUNDATION_JOURNEY_IDS,
  ...BROADER_JOURNEY_IDS,
  ...SPECIALIST_JOURNEY_IDS,
]);

export function applyHospitalJourneyQuality(journey) {
  if (!journey) return journey;

  return applySpecialistJourneyQuality(
    applyBroaderJourneyQuality(applyFoundationJourneyQuality(journey))
  );
}
